import { images } from "../../../assets/Images/assetsImages"

const FeatureCard = ({ title, image }) => {
  return (
    <div className="w-[350px] h-[550px] bg-[#F5E9D7] rounded-bl-[100px] rounded-br-[100px]">
        <div className="h-[70%] flex flex-col items-center justify-center">
            <div className="w-[80%] h-[40%] p-5">
                <h2 className="font-playfair text-3xl font-semibold text-center text-[#41220E]">{title}</h2>
            </div>
            <div className="w-[80%] h-[60%] rounded-2xl">
                {image && <img src={image} alt={title} className="w-full h-[100%] rounded-2xl object-cover" />}
            </div>
        </div>
        <div className="w-full h-[30%] flex items-center">
            <img src={images.FeatureCardLogo} alt="logoicon" className="opacity-30 xs:ml-[30%] ml-[35%]"></img>
        </div>
    </div>
  )
}

export default FeatureCard
